import React, { useCallback, useRef, useState } from 'react'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { isValidIMEI } from '@/common/validators'
import { QRScanner } from '@/components/qr/scanner'
import { useNavigate } from 'react-router-dom'
import { MainLayout, MainPageLayout } from '@/components/layout/MainLayout'

import './scanner.css'
import { BackButton } from '@/components/layout/NavBar'
import { openAppUrl } from '@/common/reactnav'

interface Props { 
  session: CurrentSession 
  services: Services
}

export const UniversalQRScannerBody: React.FC<Props> = ({ services, session }) => {
  const [scannerData, setScannerData] = useState<string>()
  const navigate = useNavigate()
  const navigatedRef = useRef(false)
  const onScan = useCallback((data: string) => {
    if (/^https?:\/\//i.test(data)) {
      // The helper checks the host and port and uses the app's current protocol.
      // The scanner may report the same code several times; navigate only once.
      if (!navigatedRef.current) {
        navigatedRef.current = openAppUrl(navigate, data)
      }
      return
    }
    setScannerData(data)
  }, [navigate])

  return <div>
    <QRScanner
      onScan={onScan}
      services={services}
    />
    {scannerData
      ? isValidIMEI(scannerData)
        ? `IMEI: ${scannerData}`
        : null
      : null}
  </div>
}

export const UniversalQRScannerPage: React.FC<Props> = (props) => {
  var { services, session } = props;
  return (
    <MainPageLayout pageName='qr-scanner' {...props} translates={props.session.translates}
        navbarLeft={<BackButton services={services} translates={session.translates} />}>
      <UniversalQRScannerBody {...props} />
    </MainPageLayout>
  )
}
